// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCJ05T29BudfkI-MUUp261Vm0Ea4vtQiAw",
  authDomain: "netflix-gpt-5d8d7.firebaseapp.com",
  projectId: "netflix-gpt-5d8d7",
  storageBucket: "netflix-gpt-5d8d7.appspot.com",
  messagingSenderId: "457895270045",
  appId: "1:457895270045:web:1194c9352867f3dd8de674",
  measurementId: "G-M5DY5ZS1VF",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth();
